/* ***************************************
This mixin "exposes" (ALL FOR NikudResultsContainer)...
... the computed properties...
  * "canRedo" and "canUndo"
... and the methods:
  * "redo()" and "undo()"
Of those, using special "dependencies" are:
  * "redo()" and "undo()" use this mixin's internal method updateContext(),
    which uses the NikudMixins method getSafeWordAndLetter()
(all else should be considered "internal")
*************************************** */

const EMPTY_STATE = 'emptyState';
const TRACKED_COMMITS /* for REDO */ = ['SET_ENTIRE_STATE', 'UPDATE_USER_DICTIONARY', 'STORE_ALL_WORKING_NIKUD',
  'REWRITE_WORD_IN_WORKING_ARRAY', 'SPLICE_WORDS_IN_WORKING_ARRAY']
const UNDOABLE_COMMITS = ['UPDATE_USER_DICTIONARY', 'REWRITE_WORD_IN_WORKING_ARRAY', 'SPLICE_WORDS_IN_WORKING_ARRAY']

export default {
  name: 'vuexUndoRedo',
      data() {
        return {
          done: [],
          undone: [],
          newMutation: true
        };
      },
      created() {
        if (this.$store) {
          this.$store.subscribe(mutation => {
            if (mutation.type !== EMPTY_STATE && TRACKED_COMMITS.includes(mutation.type)) {
              this.done.push(mutation);
            } // the second condition in the line below is crucial for our app to work -- DL
            if (this.newMutation && TRACKED_COMMITS.includes(mutation.type)) {
              this.undone = [];
            }
          });
        }
      },
      computed: {
        canRedo() {
          return this.undone.length;
        },
        canUndo() {
          return this.done.filter(commit => UNDOABLE_COMMITS.includes(commit.type)).length;
        }
      },
      methods: {
        redo() {
          let commit = this.undone.pop();
          this.newMutation = false;
          /* always an object, so skipping this */
          // if (typeof commit.payload !== 'object') {
            // this.$store.commit(`${commit.type}`, commit.payload)
          // } else {
          this.$store.commit(`${commit.type}`, Object.assign({}, commit.payload));
          // }
          this.newMutation = true;
          this.updateContext(commit.payload.contextData)
        },
        undo() {
          const lastMutation = this.done.pop()
          this.undone.push(lastMutation);
          this.newMutation = false;
          this.$store.commit(EMPTY_STATE);
          this.done.forEach(mutation => {
            // if (typeof mutation.payload !== 'object') {
              // this.$store.commit(`${mutation.type}`, mutation.payload)
            // } else {
            this.$store.commit(`${mutation.type}`, Object.assign({}, mutation.payload))
            // }
            this.done.pop()
          });
          this.newMutation = true;
          this.updateContext(lastMutation.payload.contextData)
        },
        updateContext(contextData) {
          this.$store.commit('SET_WORD_AND_LETTER', 
            this.getSafeWordAndLetter(contextData.wordIndex, contextData.letterIndex))
        }        
      }
}
